import React, { useEffect, useReducer, useState } from 'react';
import {
  Box,
  Container,
  Stack,
  Grid,
  Typography,
  FormControl,
  TextField,
  Stepper,
  Step,
  StepLabel,
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogActions,
  DialogContent,
  Button,
  FormHelperText,
  FormLabel,
  FormGroup,
  Autocomplete,
  Checkbox,
  Divider,
  IconButton,
  FormControlLabel,
  Tooltip
} from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { Link, useNavigate } from 'react-router-dom';
// import dayjs from 'dayjs';
// import { WatDatePicker } from 'thaidatepicker-react';
import { ImNotification } from 'react-icons/im';
import { FaRegSmile } from 'react-icons/fa';
import PageHeading from '../../global/header/PageHeading';

import onBoardingEkycServices from '../../../services/onBoarding-ekyc-services';
import DialogMsg from '../../global/DialogMsg';
import { userDataFromLocal } from '../utils/getUserDetails';
import Loader from '../../global/Loader';
import { Close, InfoOutlined } from '@mui/icons-material';
import OtpInput from 'react-otp-input';
import { TiTick } from 'react-icons/ti';
import { useTranslation } from 'react-i18next';

const { AadharOTPSend, AadharVerification, PanVerification, SaveUserInfo } = onBoardingEkycServices;

const PersonalInfo = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [activeStep, setActiveStep] = useState(0);
  const [dialogMsg, setDialogMsg] = useState(false);
  const [openDialogeMsg, setOpenDialogeMsg] = useState(false);
  const [openloader, setOpenloader] = useState(false);
  console.log('activeStep', activeStep);

  // 1st step state to data store here
  const [isAadharVerify, setIsAadharVerify] = useState(false);
  const [isAadharVerifyFailed, setIsAadharVerifyFailed] = useState(false);
  const [isPanVerify, setIsPanVerify] = useState(false);
  const [isPanVerifyFailed, setIsPanVerifyFailed] = useState(false);

  const initialValue = {
    aadhaar_number: '',
    pan_card_number: '',
    date_of_birth: '',
    prefix: 'Mr.',
    fatherPrefix: 'Mr',
    motherPrefix: 'Mrs',
    gender: '',
    name: '',
    maritalStatus: '',
    occupation: '',
    father_name: '',
    father_middle_name: '',
    father_last_name: '',
    motherName: '',
    mother_first_name: '',
    mother_middle_name: '',
    mother_last_name: '',

    religion: '',
    education: '',
    annualIncome: '',
    branch: '',
    emailId: '',
    // account_type: '',
    category: 'Individual',
    // number: '',
    nationality: 'Indian',
    residentStatus: 'Indian',
    customerType: 'Individual',
    address: '',
    permanent_area: '',
    permanent_city: '',
    permanent_district: '',
    permanent_pincode: '',
    permanent_state: '',
    corresponding_address: '',
    corresponding_area: '',
    corresponding_city: '',
    corresponding_district: '',
    corresponding_pincode: '',
    corresponding_state: '',
    parents_name: '',
    sales_code: ''
  };
  const [userAccessValues, DispatchUserAccesValues] = useReducer(reduceUserAccess, initialValue); // UserReducer using for multiple state
  console.log('userAccessValues', userAccessValues);

  function reduceUserAccess(prevState, nextStateAction) {
    console.log('stateprevState', prevState, nextStateAction);
    return {
      ...prevState,
      [nextStateAction.type]: nextStateAction.value
    };
  }

  // Active step controller
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    // localStorage.setItem('personalInfo', JSON.stringify(userAccessValues)); // set Steps data
  };
  const handlePrev = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  // handleSaveUserInfoApi API
  const handleSaveUserInfoApi = async () => {
    try {
      setOpenloader(true);
      const userData = userDataFromLocal();

      const headerCredential = {
        docId: userData?.id
      };

      let getKeyfield = '';
      let getAadharAddress = '';
      let getGender = '';
      let getHouseBuilding = '';
      let getAadharStreet = '';
      let getLandmark = '';
      let getCityDistrict = '';
      let getAadharState = '';
      let getAadharPincode = '';
      let getAadharCountry = '';
      let getAadharFrontUrl = '';
      let getAadharFrontUrlName = '';
      let getAadharBackUrl = '';
      let getAadharBackUrlName = '';
      let getElectricityBillUrl = '';
      let getElectricityBillName = '';
      let getTelephoneBillUrl = '';
      let getTelephoneBillName = '';
      let getCustomerSignUrl = '';
      let getCustomerSignName = '';
      let getDocWithSelfieUrl = '';
      let getDocWithSelfieName = '';
      let getSelfieDocUrl = '';
      let getSelfieDocName = '';
      let getSalesCode = '';
      let getMobileNumber = '';

      if (userData && Object.keys(userData).length > 0) {
        getSalesCode = userData?.salesCode ? userData?.salesCode : '';
        getMobileNumber = userData?.mobileNumber ? userData?.mobileNumber : '';
      }

      if (
        userData &&
        userData?.OCR?.doc_aadhar &&
        Object.keys(userData.OCR.doc_aadhar).length > 0
      ) {
        getKeyfield = userData?.OCR?.doc_aadhar?.keyfield
          ? userData?.OCR?.doc_aadhar?.keyfield
          : '';
        getAadharAddress = userData?.OCR?.doc_aadhar?.address
          ? userData?.OCR?.doc_aadhar?.address
          : '';
        getGender = userData?.OCR?.doc_aadhar?.gender ? userData?.OCR?.doc_aadhar?.gender : '';
        getHouseBuilding = userData?.OCR?.doc_aadhar?.house_buiding_no
          ? userData?.OCR?.doc_aadhar?.house_buiding_no
          : '';
        getAadharStreet = userData?.OCR?.doc_aadhar?.street
          ? userData?.OCR?.doc_aadhar?.street
          : '';
        getLandmark = userData?.OCR?.doc_aadhar?.landmark
          ? userData?.OCR?.doc_aadhar?.landmark
          : '';
        getCityDistrict = userData?.OCR?.doc_aadhar?.city_district
          ? userData?.OCR?.doc_aadhar?.city_district
          : '';
        getAadharState = userData?.OCR?.doc_aadhar?.state ? userData?.OCR?.doc_aadhar?.state : '';
        getAadharPincode = userData?.OCR?.doc_aadhar?.pincode
          ? userData?.OCR?.doc_aadhar?.pincode
          : '';
        getAadharCountry = userData?.OCR?.doc_aadhar?.country
          ? userData?.OCR?.doc_aadhar?.country
          : '';
        // without watermark image, no upload image api data
        getAadharFrontUrl = userData?.OCR?.doc_aadhar?.doc_url
          ? userData?.OCR?.doc_aadhar?.doc_url
          : '';
        getAadharFrontUrlName = userData?.OCR?.doc_aadhar?.doc_name
          ? userData?.OCR?.doc_aadhar?.doc_name
          : '';
        getAadharBackUrl = userData?.OCR?.doc_aadhar?.doc_back_url
          ? userData?.OCR?.doc_aadhar?.doc_back_url
          : '';
        getAadharBackUrlName = userData?.OCR?.doc_aadhar?.doc_back_name
          ? userData?.OCR?.doc_aadhar?.doc_back_name
          : '';
      }
      // aadhar front and back url handling and get key from local storage

      //  Non Ocr handling and get key from local storage
      if (
        userData &&
        userData?.NonOCR?.doc_electricity_bill &&
        Object.keys(userData.NonOCR.doc_electricity_bill).length > 0 &&
        userData?.NonOCR?.doc_electricity_bill?.doc_url_front_electricity_bill &&
        Object.keys(userData?.NonOCR?.doc_electricity_bill?.doc_url_front_electricity_bill).length >
          0
      ) {
        getElectricityBillUrl = userData?.NonOCR?.doc_electricity_bill
          ?.doc_url_front_electricity_bill?.doc_url
          ? userData?.NonOCR?.doc_electricity_bill?.doc_url_front_electricity_bill?.doc_url
          : '';
        getElectricityBillName = userData?.NonOCR?.doc_electricity_bill
          ?.doc_url_front_electricity_bill?.doc_name
          ? userData?.NonOCR?.doc_electricity_bill?.doc_url_front_electricity_bill?.doc_name
          : '';
      }
      if (
        userData &&
        userData?.NonOCR?.doc_telephone_bill &&
        Object.keys(userData.NonOCR.doc_telephone_bill).length > 0 &&
        userData?.NonOCR?.doc_telephone_bill?.doc_url_front_telephone_bill &&
        Object.keys(userData?.NonOCR?.doc_telephone_bill?.doc_url_front_telephone_bill).length > 0
      ) {
        getTelephoneBillUrl = userData?.NonOCR?.doc_telephone_bill?.doc_url_front_telephone_bill
          ?.doc_url
          ? userData?.NonOCR?.doc_telephone_bill?.doc_url_front_telephone_bill?.doc_url
          : '';
        getTelephoneBillName = userData?.NonOCR?.doc_telephone_bill?.doc_url_front_telephone_bill
          ?.doc_name
          ? userData?.NonOCR?.doc_telephone_bill?.doc_url_front_telephone_bill?.doc_name
          : '';
      }
      if (
        userData &&
        userData?.NonOCR?.doc_customer_sign &&
        Object.keys(userData.NonOCR.doc_customer_sign).length > 0 &&
        userData?.NonOCR?.doc_customer_sign?.doc_url_front_customer_sign &&
        Object.keys(userData?.NonOCR?.doc_customer_sign?.doc_url_front_customer_sign).length > 0
      ) {
        getCustomerSignUrl = userData?.NonOCR?.doc_customer_sign?.doc_url_front_customer_sign
          ?.doc_url
          ? userData?.NonOCR?.doc_customer_sign?.doc_url_front_customer_sign?.doc_url
          : '';
        getCustomerSignName = userData?.NonOCR?.doc_customer_sign?.doc_url_front_customer_sign
          ?.doc_name
          ? userData?.NonOCR?.doc_customer_sign?.doc_url_front_customer_sign?.doc_name
          : '';
      }
      //  docwith selfie handling and get key from local storage
      if (userData && userData?.docWithSelfie && Object.keys(userData?.docWithSelfie).length > 0) {
        getDocWithSelfieUrl = userData?.docWithSelfie?.doc_url
          ? userData?.docWithSelfie?.doc_url
          : '';
        getDocWithSelfieName = userData?.docWithSelfie?.doc_name
          ? userData?.docWithSelfie?.doc_name
          : '';
      }
      // facematch key handling  and get key from local storage
      // if (
      //   userData &&
      //   userData?.selfie &&
      //   Object.keys(userData?.selfie).length > 0 &&
      //   userData?.selfie?.selfieDocurl &&
      //   Object.keys(userData?.selfie?.selfieDocurl).length > 0
      // ) {
      //   getSelfieDocUrl = userData?.selfie?.selfieDocurl?.doc_url
      //     ? userData?.selfie?.selfieDocurl?.doc_url
      //     : '';
      //   getSelfieDocName = userData?.selfie?.selfieDocurl?.doc_name
      //     ? userData?.selfie?.selfieDocurl?.doc_name
      //     : '';
      // }
      if (
        userData &&
        userData?.selfie &&
        Object.keys(userData?.selfie).length > 0 &&
        userData?.selfie?.face_match_result &&
        Object.keys(userData?.selfie?.face_match_result).length > 0
      ) {
        getSelfieDocUrl = userData?.selfie?.face_match_result?.selfie_doc_url
          ? userData?.selfie?.face_match_result?.selfie_doc_url
          : '';
        getSelfieDocName = userData?.selfie?.face_match_result?.selfie_doc_name
          ? userData?.selfie?.face_match_result?.selfie_doc_name
          : '';
      }

      const fatherMidAndLastName = `${userAccessValues?.father_name ?? ''} ${
        userAccessValues?.father_middle_name ?? ''
      } ${userAccessValues?.father_last_name ?? ''}`;
      const motherMidAndLastName = `${userAccessValues?.motherName ?? ''} ${
        userAccessValues?.mother_middle_name ?? ''
      } ${userAccessValues?.mother_last_name ?? ''}`;

      const credential = {
        prefix: userAccessValues?.prefix,
        fatherPrefix: userAccessValues?.fatherPrefix,
        motherPrefix: userAccessValues?.motherPrefix,
        motherName: motherMidAndLastName,
        maritalStatus: userAccessValues?.maritalStatus,
        nationality: userAccessValues?.nationality,
        occupation: userAccessValues?.occupation,
        residentStatus: userAccessValues?.residentStatus,
        religion: userAccessValues?.religion,
        emailId: userAccessValues?.emailId,
        contactNumber: getMobileNumber,
        annualIncome: userAccessValues?.annualIncome,
        education: userAccessValues?.education,
        branch: userAccessValues?.branch,
        name: userAccessValues?.name,
        father_name: fatherMidAndLastName,
        date_of_birth: userAccessValues?.date_of_birth,
        pan_card_number: userAccessValues?.pan_card_number.trim(),
        aadhaar_number: userAccessValues?.aadhaar_number.trim(),
        keyfield: getKeyfield,
        address:
          getAadharAddress !== '' && getAadharAddress === userAccessValues?.address
            ? getAadharAddress
            : userAccessValues?.address,
        gender:
          getGender !== '' && getGender === userAccessValues?.gender
            ? getGender
            : userAccessValues?.gender,
        house_buiding_no: getHouseBuilding,
        // street: getAadharStreet,
        street:
          getLandmark !== '' && getLandmark === userAccessValues?.permanent_area
            ? getLandmark
            : userAccessValues?.permanent_area, // used landmark for now, because field is not available into form
        landmark:
          getLandmark !== '' && getLandmark === userAccessValues?.permanent_area
            ? getLandmark
            : userAccessValues?.permanent_area,
        // landmark: userAccessValues?.permanent_area,
        city_district:
          getCityDistrict !== '' && getCityDistrict === userAccessValues?.permanent_district
            ? getCityDistrict
            : userAccessValues?.permanent_district,
        state:
          getAadharState !== '' && getAadharState === userAccessValues?.permanent_state
            ? getAadharState
            : userAccessValues?.permanent_state,
        pincode:
          getAadharPincode !== '' && getAadharPincode === userAccessValues?.permanent_pincode
            ? getAadharPincode
            : userAccessValues?.permanent_pincode,
        country:
          getAadharCountry !== '' && getAadharCountry === userAccessValues?.nationality
            ? getAadharCountry
            : userAccessValues?.nationality,
        application_no: userData && userData?.applicationNo ? userData?.applicationNo : '',

        local_address: userAccessValues?.corresponding_address,
        // local_street: getAadharStreet, // used street for now, because field is not available into form
        local_street: userAccessValues?.corresponding_area, // used landmark for now, because field is not available into form
        local_landmark: userAccessValues?.corresponding_area,
        local_city_district: userAccessValues?.corresponding_district,
        local_state: userAccessValues?.corresponding_state,
        local_pincode: userAccessValues?.corresponding_pincode,
        local_country: userAccessValues?.nationality,

        doc_name: getAadharFrontUrlName,
        doc_url: getAadharFrontUrl,
        doc_back_name: getAadharBackUrlName,
        doc_back_url: getAadharBackUrl,
        selfie_doc_url: getSelfieDocUrl,
        selfie_doc_name: getSelfieDocName,
        id_doc_url: getDocWithSelfieUrl,
        id_doc_name: getDocWithSelfieName,
        aadharStatus: isAadharVerify,
        panStatus: isPanVerify,
        sales_code: getSalesCode,
        ELECTRICITY_BILL_name: getElectricityBillName,
        ELECTRICITY_BILL_url: getElectricityBillUrl,
        TELEPHONE_BILL_name: getTelephoneBillName,
        TELEPHONE_BILL_url: getTelephoneBillUrl,
        CUSTOMER_SIGN_name: getCustomerSignName,
        CUSTOMER_SIGN_url: getCustomerSignUrl
      };

      // const credential = {
      //   ...userAccessValues,
      //   application_no: userData?.applicationNo,
      //   doc_name: userData?.OCR?.doc_aadhar?.doc_name,
      //   doc_url: userData?.OCR?.doc_aadhar?.doc_url
      // };

      const SaveUserInfoResponse = await SaveUserInfo(headerCredential, credential);
      if (SaveUserInfoResponse.status === 'Success') {
        navigate('/in/thanks');
      } else if (SaveUserInfoResponse.status === 'Failed') {
        setOpenDialogeMsg(true);
        setDialogMsg(SaveUserInfoResponse.message);
      } else {
        setOpenDialogeMsg(true);
        setDialogMsg(t('Something went wrong'));
      }
    } catch (error) {
      console.log('errorerror', error);
    } finally {
      setOpenloader(false);
    }
  };

  // Msg Dialog close handler
  const closeDialogMsgHandler = (e) => {
    setOpenDialogeMsg(false);
    setDialogMsg('');
  };

  useEffect(() => {
    // Check if 'existingJourney' exists in local storage, parse it from JSON, or initialize as an empty object
    // let existingJourney = localStorage.getItem('journey');
    // existingJourney = existingJourney ? JSON.parse(existingJourney) : {};
    const userData = userDataFromLocal();
    if (userData && userData?.OCR?.doc_aadhar && Object.keys(userData.OCR.doc_aadhar).length > 0) {
      Object.keys(userData?.OCR?.doc_aadhar).forEach((key) => {
        Object.keys(userAccessValues).forEach((localData) => {
          if (key === localData) {
            DispatchUserAccesValues({
              type: key,
              value: userData?.OCR?.doc_aadhar[key]
              // value: Object.values(userData?.OCR?.doc_aadhar)[index]
            });
          }
        });
      });
    }

    // for the time being 1 keys fill if other OCR
    DispatchUserAccesValues({
      type: 'pan_card_number',
      value: userData?.OCR?.doc_pan?.pan_card_number ? userData?.OCR?.doc_pan?.pan_card_number : ''
    });
    DispatchUserAccesValues({
      type: 'address',
      value: userData?.OCR?.doc_aadhar?.address ? userData?.OCR?.doc_aadhar?.address : ''
    });
    // DispatchUserAccesValues({
    //   type: 'address',
    //   value: userData?.OCR?.doc_aadhar?.address ? userData?.OCR?.doc_aadhar?.address : ''
    // });
    DispatchUserAccesValues({
      type: 'permanent_state',
      value: userData?.OCR?.doc_aadhar?.state ? userData?.OCR?.doc_aadhar?.state : ''
    });
    DispatchUserAccesValues({
      type: 'permanent_city',
      value: userData?.OCR?.doc_aadhar?.city_district
        ? userData?.OCR?.doc_aadhar?.city_district
        : ''
    });

    DispatchUserAccesValues({
      type: 'permanent_pincode',
      value: userData?.OCR?.doc_aadhar?.pincode ? userData?.OCR?.doc_aadhar?.pincode : ''
    });
    DispatchUserAccesValues({
      type: 'permanent_district',
      value: userData?.OCR?.doc_aadhar?.city_district
        ? userData?.OCR?.doc_aadhar?.city_district
        : ''
    });
    DispatchUserAccesValues({
      type: 'permanent_area',
      value: userData?.OCR?.doc_aadhar?.landmark ? userData?.OCR?.doc_aadhar?.landmark : ''
    });

    // DispatchUserAccesValues({
    //   type: 'number',
    //   value: userData?.mobileNumber
    // });
  }, []);

  return (
    <>
      <Loader openloader={openloader} />
      <PageHeading pageTitle="Personal info" />
      <Container maxWidth="lg" className="selfRegistrationContainer">
        <Box>
          <Stepper
            //   connector=""
            activeStep={activeStep}
            sx={{ marginBottom: '25px' }}
            className="stepWizardOuter"
          >
            <Step className="stepWizard">
              <StepLabel className="stepWizardLabel" classes={{ iconContainer: 'iconContainer' }}>
                {t('Personal Details')}
              </StepLabel>
            </Step>

            <Step className="stepWizard">
              <StepLabel className="stepWizardLabel" classes={{ iconContainer: 'iconContainer' }}>
                {t('Other Details')}
              </StepLabel>
            </Step>

            <Step className="stepWizard">
              <StepLabel className="stepWizardLabel" classes={{ iconContainer: 'iconContainer' }}>
                {t('Address')}
              </StepLabel>
            </Step>

            <Step className="stepWizard">
              <StepLabel className="stepWizardLabel" classes={{ iconContainer: 'iconContainer' }}>
                {t('Summary')}
              </StepLabel>
            </Step>
          </Stepper>
          {activeStep === 0 ? (
            <Step1Content
              setOpenloader={setOpenloader}
              handleNext={handleNext}
              userAccessValues={userAccessValues}
              DispatchUserAccesValues={DispatchUserAccesValues}
              isAadharVerify={isAadharVerify}
              setIsAadharVerify={setIsAadharVerify}
              isAadharVerifyFailed={isAadharVerifyFailed}
              setIsAadharVerifyFailed={setIsAadharVerifyFailed}
              isPanVerify={isPanVerify}
              setIsPanVerify={setIsPanVerify}
              isPanVerifyFailed={isPanVerifyFailed}
              setIsPanVerifyFailed={setIsPanVerifyFailed}
            />
          ) : activeStep === 1 ? (
            <Step2Content
              handleNext={handleNext}
              handlePrev={handlePrev}
              userAccessValues={userAccessValues}
              DispatchUserAccesValues={DispatchUserAccesValues}
            />
          ) : activeStep === 2 ? (
            <Step3Content
              handleNext={handleNext}
              handlePrev={handlePrev}
              // setActiveStep={setActiveStep}
              userAccessValues={userAccessValues}
              DispatchUserAccesValues={DispatchUserAccesValues}
              // userAccessValues={userAccessValues}
              // handleSaveUserInfoApi={handleSaveUserInfoApi}
            />
          ) : (
            <Step4Content
              handlePrev={handlePrev}
              setActiveStep={setActiveStep}
              userAccessValues={userAccessValues}
              handleSaveUserInfoApi={handleSaveUserInfoApi}
            />
          )}
        </Box>

        {/* Dialog msg */}
        <DialogMsg
          openDialogeMsg={openDialogeMsg}
          dialogMsg={dialogMsg}
          dialogTitle="Message"
          buttonText="Close"
          closeDialogMsgHandler={closeDialogMsgHandler}
        />
      </Container>
    </>
  );
};

export default PersonalInfo;

const Step1Content = ({
  setOpenloader,
  handleNext,
  userAccessValues,
  DispatchUserAccesValues,
  isAadharVerify,
  setIsAadharVerify,
  isAadharVerifyFailed,
  setIsAadharVerifyFailed,
  isPanVerify,
  setIsPanVerify,
  isPanVerifyFailed,
  setIsPanVerifyFailed
}) => {
  const { t } = useTranslation();
  const [validationMsg, setValidationMsg] = useState(false); // Validation error
  const [openDialogVerify, setOpenDialogVerify] = useState(false); // Validation error
  const [otp, setOtp] = useState(''); // OTP digit state used into dialog
  const [dialogMsg, setDialogMsg] = useState(false);
  const [openDialogeMsg, setOpenDialogeMsg] = useState(false);
  const [isOtp, setIsOtp] = useState(null);
  const [referenceId, setReferenceId] = useState('');
  // const [isAadharVerify, setIsAadharVerify] = useState(false);
  // const [isPanVerify, setIsPanVerify] = useState(false);

  // Send mobile OTP API
  const handleAadharOTPSend = async () => {
    try {
      setOpenloader(true);
      const userData = userDataFromLocal();
      const hdrCredential = {
        organizationId: 1,
        aadharCardNo: userAccessValues?.aadhaar_number.trim(),
        applicationNo: userData ? userData?.applicationNo : ''
      };
      const AadharOTPResponse = await AadharOTPSend(hdrCredential);
      if (AadharOTPResponse.status === 'SUCCESS') {
        setReferenceId(AadharOTPResponse?.data?.referId);
        setIsOtp(AadharOTPResponse.message);
        setOpenDialogVerify(true);
      } else if (AadharOTPResponse.status === 'FAILED') {
        setOpenDialogeMsg(true);
        setDialogMsg(`${AadharOTPResponse?.message}, Please retry again`);
      } else {
        setOpenDialogeMsg(true);
        setDialogMsg(`${AadharOTPResponse?.message}, Please retry again`);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setOpenloader(false);
    }
  };
  // Aadhar verfiy OTP
  const handleAadharOTPVerify = async () => {
    try {
      setOpenloader(true);
      const userData = userDataFromLocal();
      const hdrCredential = {
        organizationId: 1,
        aadharCardNo: userAccessValues?.aadhaar_number.trim(),
        applicationNo: userData ? userData?.applicationNo : '',
        otp: otp,
        referId: referenceId
      };
      const AadharOTPVerifyResponse = await AadharVerification(hdrCredential);
      if (AadharOTPVerifyResponse.status === 'SUCCESS') {
        setIsAadharVerify(true);
        setOpenDialogVerify(false);
      } else if (
        AadharOTPVerifyResponse.status === 'FAILED' ||
        AadharOTPVerifyResponse.status === 'error'
      ) {
        setIsAadharVerifyFailed(true);
        setOpenDialogeMsg(true);
        setDialogMsg(`${AadharOTPVerifyResponse?.message}, Please retry again`);
      } else {
        setOpenDialogeMsg(true);
        setDialogMsg(`${AadharOTPVerifyResponse?.message}, Please retry again`);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setOpenloader(false);
    }
  };
  // Aadhar verfiy OTP
  const handlePanVerification = async () => {
    try {
      setOpenloader(true);
      const userData = userDataFromLocal();
      const hdrCredential = {
        organizationId: 1,
        panNo: userAccessValues?.pan_card_number,
        applicationNo: userData ? userData?.applicationNo : ''
      };
      const PanVerifyResponse = await PanVerification(hdrCredential);
      if (PanVerifyResponse.status === 'SUCCESS') {
        setIsPanVerify(true);
        setDialogMsg(PanVerifyResponse.message);
      } else if (PanVerifyResponse.status === 'FAILED') {
        setIsPanVerifyFailed(true);
        setOpenDialogeMsg(true);
        setDialogMsg(PanVerifyResponse?.message);
      } else {
        setOpenDialogeMsg(true);
        setDialogMsg(PanVerifyResponse?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setOpenloader(false);
    }
  };

  // Msg Dialog close handler
  const closeDialogMsgHandler = (e) => {
    setOpenDialogeMsg(false);
    setDialogMsg('');
  };

  return (
    <>
      <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography
            variant="body2"
            mb={1}
            className="FormLabel"
            display="flex"
            justifyContent="space-between"
          >
            <FormLabel required>{t('Aadhar card number')}</FormLabel>

            <FormLabel
              style={{
                color: isAadharVerify !== false ? 'green' : '#FFA23A',
                cursor: userAccessValues?.aadhaar_number !== '' ? 'pointer' : 'default',
                opacity: userAccessValues?.aadhaar_number !== '' ? 1 : 0.4,
                fontSize: '13px',
                display: 'flex',
                alignItems: 'center'
              }}
              onClick={() => {
                if (userAccessValues?.aadhaar_number !== '') {
                  handleAadharOTPSend();
                }
              }}
            >
              <span style={{ marginRight: '3px' }}>{t('Aadhar')}</span>{' '}
              {/* {isAadharVerify !== false ? (
                <span>
                  verified <TiTick />
                </span>
              ) : isAadharVerify === false ? (
                'reverify'
              ) : (
                'verify'
              )} */}
              {isAadharVerify === true ? (
                <span>
                  {t('verified')} <TiTick />
                </span>
              ) : isAadharVerifyFailed === true ? (
                <span>{t('reverify')}</span>
              ) : (
                <>
                  <span>{t('verify')}</span>{' '}
                  <Tooltip
                    title={
                      <Box>
                        <Typography color="inherit" component="div" style={{ fontSize: '12px' }}>
                          {t('Aadhaar verification is mandatory')}
                        </Typography>
                      </Box>
                    }
                    placement="top"
                    arrow
                  >
                    <InfoOutlined
                      style={{ fontSize: '14px', cursor: 'pointer', marginLeft: '3px' }}
                    />
                  </Tooltip>
                </>
              )}
            </FormLabel>
          </Typography>
          <TextField
            required
            fullWidth
            className="frmHelperAlign"
            inputProps={{ className: 'formControl' }}
            placeholder={t('Type aadhar number')}
            value={userAccessValues.aadhaar_number}
            onChange={(e) => {
              if (e.target.value.length < 16) {
                DispatchUserAccesValues({ type: 'aadhaar_number', value: e.target.value });
              }
            }}
            error={userAccessValues.aadhaar_number === '' ? validationMsg : false}
            helperText={
              (userAccessValues.aadhaar_number === undefined ||
                userAccessValues.aadhaar_number === '') &&
              validationMsg === true
                ? t('Please fill aadhar number')
                : ''
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography
            variant="body2"
            mb={1}
            className="FormLabel"
            display="flex"
            justifyContent="space-between"
          >
            <FormLabel required>{t('Pan number')}</FormLabel>
            <FormLabel
              style={{
                color: isPanVerify !== false ? 'green' : '#FFA23A',
                cursor: userAccessValues?.pan_card_number !== '' ? 'pointer' : 'default',
                opacity: userAccessValues?.pan_card_number !== '' ? 1 : 0.4,
                fontSize: '13px',
                display: 'flex',
                alignItems: 'center'
              }}
              onClick={() => {
                if (userAccessValues?.pan_card_number !== '') {
                  handlePanVerification();
                }
              }}
            >
              <span style={{ marginRight: '3px' }}>{t('Pan')}</span>{' '}
              {isPanVerify === true ? (
                <span>
                  {t('verified')} <TiTick />
                </span>
              ) : isPanVerifyFailed === true ? (
                <span>{t('reverify')}</span>
              ) : (
                <>
                  <span>{t('verify')}</span>
                  <Tooltip
                    title={
                      <Box>
                        <Typography color="inherit" component="div" style={{ fontSize: '12px' }}>
                          {t('Pan verification is mandatory')}
                        </Typography>
                      </Box>
                    }
                    placement="top"
                    arrow
                  >
                    <InfoOutlined
                      style={{ fontSize: '14px', cursor: 'pointer', marginLeft: '3px' }}
                    />
                  </Tooltip>
                </>
              )}
            </FormLabel>
          </Typography>

          <Typography>
            <TextField
              required
              fullWidth
              type="text"
              className="frmHelperAlign"
              inputProps={{
                className: 'formControl'
              }}
              placeholder={t('Pan number')}
              value={userAccessValues.pan_card_number}
              onChange={(e) => {
                if (e.target.value.length < 11) {
                  DispatchUserAccesValues({ type: 'pan_card_number', value: e.target.value });
                }
              }}
              error={userAccessValues.pan_card_number === '' ? validationMsg : false}
              helperText={
                (userAccessValues.pan_card_number === undefined ||
                  userAccessValues.pan_card_number === '') &&
                validationMsg === true
                  ? t('Please fill your pan number')
                  : ''
              }
            />
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel required>{t('Date of birth')}</FormLabel>
          </Typography>
          <TextField
            inputProps={{
              className: 'formControl'
            }}
            className="frmHelperAlign"
            fullWidth
            type="date"
            placeholder={t('dd-mm-yyyy')}
            style={{ opacity: userAccessValues.date_of_birth === '' ? '.5' : '1' }}
            value={userAccessValues.date_of_birth.split('/').reverse().join('-')}
            onChange={(e) =>
              DispatchUserAccesValues({ type: 'date_of_birth', value: e.target.value })
            }
            error={userAccessValues.date_of_birth === '' ? validationMsg : false}
            helperText={
              (userAccessValues.date_of_birth === undefined ||
                userAccessValues.date_of_birth === '') &&
              validationMsg === true
                ? t('Please fill your date of birth ')
                : ''
            }
          />
        </Grid>
        <Grid item xs={12} sm={2} md={2}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel>{t('Prefix')}</FormLabel>
          </Typography>
          <Select
            fullWidth
            value={userAccessValues.prefix}
            onChange={(e) => DispatchUserAccesValues({ type: 'prefix', value: e.target.value })}
            className="frmHelperAlign"
            inputProps={{
              className: 'formControl'
            }}
          >
            <MenuItem value="Mr.">{t('Mr')}</MenuItem>
            <MenuItem value="Mrs.">{t('Mrs')}.</MenuItem>
            <MenuItem value="Miss.">{t('Miss')}</MenuItem>
          </Select>
        </Grid>
        <Grid item xs={12} sm={2} md={2}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel required>{t('Gender')}</FormLabel>
          </Typography>
          <Typography>
            <Select
              fullWidth
              value={userAccessValues.gender}
              onChange={(e) => DispatchUserAccesValues({ type: 'gender', value: e.target.value })}
              className="frmHelperAlign"
              inputProps={{
                className: `formControl dissabledMenu${userAccessValues.gender}`
              }}
              displayEmpty
              error={userAccessValues.gender === '' ? validationMsg : false}
              renderValue={(selected) => (selected === '' ? t('Select Gender') : selected)}
            >
              <MenuItem value="" disabled>
                {t('Select Gender')}
              </MenuItem>
              <MenuItem value="Male">{t('Male')}</MenuItem>
              <MenuItem value="Female">{t('Female')}</MenuItem>
              <MenuItem value="Others">{t('Others')}</MenuItem>
            </Select>
            <FormHelperText className="selectHelper" error>
              {userAccessValues.gender === '' && validationMsg ? t('Please select gender') : ''}
            </FormHelperText>
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel required>{t('Name')}</FormLabel>
          </Typography>
          <TextField
            fullWidth
            type="text"
            className="frmHelperAlign"
            inputProps={{
              className: 'formControl'
            }}
            placeholder={t('Type your name')}
            value={userAccessValues.name}
            onChange={(e) => DispatchUserAccesValues({ type: 'name', value: e.target.value })}
            error={userAccessValues.name === '' ? validationMsg : false}
            helperText={
              (userAccessValues.name === undefined || userAccessValues.name === '') &&
              validationMsg === true
                ? t('Please fill name')
                : ''
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel required>{t('Marital Status')}</FormLabel>
          </Typography>
          <Typography>
            <Select
              fullWidth
              value={userAccessValues.maritalStatus}
              onChange={(e) =>
                DispatchUserAccesValues({ type: 'maritalStatus', value: e.target.value })
              }
              className="frmHelperAlign"
              inputProps={{
                className: `formControl dissabledMenu${userAccessValues.maritalStatus}`
              }}
              displayEmpty
              error={userAccessValues.maritalStatus === '' ? validationMsg : false}
              renderValue={(selected) => (selected === '' ? t('Marital Status') : selected)}
            >
              <MenuItem value="" disabled>
                {t('Marital status')}
              </MenuItem>
              <MenuItem value="Married">{t('Married')}</MenuItem>
              <MenuItem value="Unmarried">{t('Unmarried')}</MenuItem>
              <MenuItem value="Divorce">{t('Divorce')}</MenuItem>
              <MenuItem value="Widowed">{t('Widowed')}</MenuItem>
            </Select>
            <FormHelperText className="selectHelper" error>
              {userAccessValues.maritalStatus === '' && validationMsg
                ? t('Please select martial status')
                : ''}
            </FormHelperText>
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel required>{t('Occupation Employment status')}</FormLabel>
          </Typography>
          <Typography>
            <Select
              fullWidth
              value={userAccessValues.occupation}
              onChange={(e) =>
                DispatchUserAccesValues({ type: 'occupation', value: e.target.value })
              }
              className="frmHelperAlign"
              inputProps={{
                className: `formControl dissabledMenu${userAccessValues.occupation}`
              }}
              displayEmpty
              error={userAccessValues.occupation === '' ? validationMsg : false}
              renderValue={(selected) => (selected === '' ? t('Occupation') : selected)}
            >
              <MenuItem value="" disabled>
                {t('Occupation')}
              </MenuItem>
              <MenuItem value="Service">{t('Service')}</MenuItem>
              <MenuItem value="Salaried">{t('Salaried')}</MenuItem>
              <MenuItem value="Business">{t('Business')}</MenuItem>
              <MenuItem value="Housewife">{t('Housewife')}</MenuItem>
              <MenuItem value="Goverment Job">{t('Government Job')}</MenuItem>
            </Select>
            <FormHelperText className="selectHelper" error>
              {userAccessValues.occupation === '' && validationMsg
                ? t('Please select occupation')
                : ''}
            </FormHelperText>
          </Typography>
        </Grid>
      </Grid>
      <Typography variant="subtitle2" className="" mt={2} mb={1}>
        {t('Father Name')}
      </Typography>
      <Grid
        container
        spacing={{ xs: 1, sm: 2, md: 3 }}
        alignItems="top"
        columns={{ xs: 12, sm: 12, md: 13 }}
      >
        <Grid item xs={12} sm={6} md={1}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel>{t('Prefix')}</FormLabel>
          </Typography>
          {/* <Select
              fullWidth
              value={userAccessValues.prefix}
              onChange={(e) => DispatchUserAccesValues({ type: 'prefix', value: e.target.value })}
              className="frmHelperAlign"
              inputProps={{
                className: 'formControl'
              }}
            >
              <MenuItem value="Mr.">Mr.</MenuItem>
              <MenuItem value="Mrs.">Mrs.</MenuItem>
              <MenuItem value="Miss.">Miss.</MenuItem>
            </Select> */}
          <TextField
            fullWidth
            type="text"
            className="frmHelperAlign"
            inputProps={{
              className: 'formControl'
            }}
            placeholder={t('Mr')}
            // value={userAccessValues.fatherPrefix}
            value={t('Mr')}
            // onChange={(e) => DispatchUserAccesValues({ type: 'prefix', value: e.target.value })}
            // error={userAccessValues.fatherPrefix === '' ? validationMsg : false}
            // helperText={
            //   (userAccessValues.fatherPrefix === undefined || userAccessValues.fatherPrefix === '') &&
            //   validationMsg === true
            //     ? 'Please fill the fatherPrefix'
            //     : ''
            // }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel required>{t('First Name')}</FormLabel>
          </Typography>
          <TextField
            fullWidth
            type="text"
            className="frmHelperAlign"
            inputProps={{
              className: 'formControl'
            }}
            placeholder={t('First Name')}
            value={userAccessValues.father_name}
            onChange={(e) =>
              DispatchUserAccesValues({ type: 'father_name', value: e.target.value })
            }
            error={userAccessValues.father_name === '' ? validationMsg : false}
            helperText={
              (userAccessValues.father_name === undefined || userAccessValues.father_name === '') &&
              validationMsg === true
                ? t('Please fill father first name')
                : ''
            }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel>{t('Middle Name')}</FormLabel>
          </Typography>
          <TextField
            fullWidth
            type="text"
            className="frmHelperAlign"
            inputProps={{
              className: 'formControl'
            }}
            placeholder={t('Middle Name')}
            value={userAccessValues.father_middle_name}
            onChange={(e) =>
              DispatchUserAccesValues({ type: 'father_middle_name', value: e.target.value })
            }
            // error={userAccessValues.father_middle_name === '' ? validationMsg : false}
            // helperText={
            //   (userAccessValues.father_middle_name === undefined ||
            //     userAccessValues.father_middle_name === '') &&
            //   validationMsg === true
            //     ? 'Please fill father middle name'
            //     : ''
            // }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel>{t('Last Name')}</FormLabel>
          </Typography>
          <TextField
            fullWidth
            type="text"
            className="frmHelperAlign"
            inputProps={{
              className: 'formControl'
            }}
            placeholder={t('Last Name')}
            value={userAccessValues.father_last_name}
            onChange={(e) =>
              DispatchUserAccesValues({ type: 'father_last_name', value: e.target.value })
            }
            // error={userAccessValues.father_last_name === '' ? validationMsg : false}
            // helperText={
            //   (userAccessValues.father_last_name === undefined ||
            //     userAccessValues.father_last_name === '') &&
            //   validationMsg === true
            //     ? 'Please fill father last name'
            //     : ''
            // }
          />
        </Grid>
      </Grid>

      <Typography variant="subtitle2" className="" mt={2} mb={1}>
        {t('Mother Name')}
      </Typography>
      <Grid
        container
        spacing={{ xs: 1, sm: 2, md: 3 }}
        alignItems="top"
        columns={{ xs: 12, sm: 12, md: 13 }}
      >
        <Grid item xs={12} sm={6} md={1}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel>{t('Prefix')}</FormLabel>
          </Typography>
          {/* <Select
              fullWidth
              value={userAccessValues.prefix}
              onChange={(e) => DispatchUserAccesValues({ type: 'prefix', value: e.target.value })}
              className="frmHelperAlign"
              inputProps={{
                className: 'formControl'
              }}
            >
              <MenuItem value="Mr.">Mr.</MenuItem>
              <MenuItem value="Mrs.">Mrs.</MenuItem>
              <MenuItem value="Miss.">Miss.</MenuItem>
            </Select> */}
          <TextField
            fullWidth
            type="text"
            className="frmHelperAlign"
            inputProps={{
              className: 'formControl'
            }}
            placeholder={t('Mrs')}
            // value={userAccessValues.motherPrefix}
            value={t('Mrs')}
            // onChange={(e) =>
            //   DispatchUserAccesValues({ type: 'motherPrefix', value: e.target.value })
            // }
            // error={userAccessValues.motherPrefix === '' ? validationMsg : false}
            // helperText={
            //   (userAccessValues.motherPrefix === undefined || userAccessValues.motherPrefix === '') &&
            //   validationMsg === true
            //     ? 'Please fill the motherPrefix'
            //     : ''
            // }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel required>{t('First Name')}</FormLabel>
          </Typography>
          <TextField
            fullWidth
            type="text"
            className="frmHelperAlign"
            inputProps={{
              className: 'formControl'
            }}
            placeholder={t('First Name')}
            value={userAccessValues.motherName}
            onChange={(e) => DispatchUserAccesValues({ type: 'motherName', value: e.target.value })}
            error={userAccessValues.motherName === '' ? validationMsg : false}
            helperText={
              (userAccessValues.motherName === undefined || userAccessValues.motherName === '') &&
              validationMsg === true
                ? t('Please fill mother first name')
                : ''
            }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel>{t('Middle Name')}</FormLabel>
          </Typography>
          <TextField
            fullWidth
            type="text"
            className="frmHelperAlign"
            inputProps={{
              className: 'formControl'
            }}
            placeholder={t('Middle Name')}
            value={userAccessValues.mother_middle_name}
            onChange={(e) =>
              DispatchUserAccesValues({ type: 'mother_middle_name', value: e.target.value })
            }
            // error={userAccessValues.mother_middle_name === '' ? validationMsg : false}
            // helperText={
            //   (userAccessValues.mother_middle_name === undefined ||
            //     userAccessValues.mother_middle_name === '') &&
            //   validationMsg === true
            //     ? 'Please fill mother middle name'
            //     : ''
            // }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel>{t('Last Name')}</FormLabel>
          </Typography>
          <TextField
            fullWidth
            type="text"
            className="frmHelperAlign"
            inputProps={{
              className: 'formControl'
            }}
            placeholder={t('Last Name')}
            value={userAccessValues.mother_last_name}
            onChange={(e) =>
              DispatchUserAccesValues({ type: 'mother_last_name', value: e.target.value })
            }
            // error={userAccessValues.mother_last_name === '' ? validationMsg : false}
            // helperText={
            //   (userAccessValues.mother_last_name === undefined ||
            //     userAccessValues.mother_last_name === '') &&
            //   validationMsg === true
            //     ? 'Please fill mother last name'
            //     : ''
            // }
          />
        </Grid>
      </Grid>
      <Box Container textAlign="right" mt={3}>
        <Button
          className="mainBtn"
          onClick={() => {
            // Check if blank field
            if (
              userAccessValues.aadhaar_number === '' ||
              userAccessValues.pan_card_number === '' ||
              isAadharVerify === false ||
              isPanVerify === false ||
              userAccessValues.date_of_birth === '' ||
              userAccessValues.gender === '' ||
              userAccessValues.name === '' ||
              userAccessValues.maritalStatus === '' ||
              userAccessValues.occupation === '' ||
              userAccessValues.father_name === '' ||
              userAccessValues.motherName === ''
            ) {
              setValidationMsg(true);
              if (!isAadharVerify) {
                setOpenDialogeMsg(true);
                setDialogMsg(t('Aadhaar verification is mandatory'));
              } else if (!isPanVerify) {
                setOpenDialogeMsg(true);
                setDialogMsg('Pan verification is mandatory');
              }
              return;
            }
            setValidationMsg(false);
            handleNext();
          }}
        >
          {t('Next')}
        </Button>
        {/* <Link to="/in/addressinfo" className="mainBtn" onClick={{ handleNext }}>
          Next
        </Link> */}
      </Box>

      <Dialog
        // fullScreen
        maxWidth="lg"
        open={openDialogVerify}
        onClose={(e) => {
          setOpenDialogVerify(false);
        }}
        className="alertDialogWrap"
      >
        <DialogTitle className="dialog-title" style={{ textAlign: 'center' }}>
          <Typography
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{ fontWeight: 'bold' }}
          >
            {t('Enter OTP')}
          </Typography>

          <IconButton onClick={(e) => setOpenDialogVerify(false)} size="small">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent
          dividers
          className="dialog-content"
          style={{
            display: 'flex',
            minHeight: '100px',
            alignItems: 'center'
          }}
        >
          <Box className="dialogMsg" width="100%" pb={1}>
            <Typography variant="body2" textAlign="center">
              {t('Please enter 6 digit code for')} <br /> {t('Aadhar')}:{' '}
              {userAccessValues?.aadhaar_number}
            </Typography>
            {isOtp !== null ? (
              <Typography
                variant="body2"
                textAlign="center"
                mt={1}
                style={{ color: 'green', fontWeight: 'bold', fontSize: '13px' }}
              >
                {isOtp}
              </Typography>
            ) : (
              ''
            )}

            <Typography
              variant="body2"
              display="flex"
              justifyContent="center"
              textAlign="center"
              mt={2}
            >
              <OtpInput
                className="otpInp"
                value={otp}
                onChange={setOtp}
                numInputs={6}
                shouldAutoFocus={true}
                renderSeparator={<span style={{ color: '#03989a' }}>-</span>}
                renderInput={(props) => <input {...props} />}
                inputStyle={{
                  margin: '0px 4px',
                  width: '32px',
                  height: '40px',
                  border: '1px solid #03989a',
                  borderRadius: '5px'
                }}
              />
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions disableSpacing={false} className="popupAction">
          <Button
            style={{ backgroundColor: otp === '' ? '#efefef' : '#111b53' }}
            disabled={otp === '' ? true : false}
            className="mainBtn"
            variant="contained"
            color="secondary"
            onClick={() => {
              // setOpenDialogVerify(false);
              handleAadharOTPVerify();
            }}
          >
            {/* Verify */}
            {isAadharVerifyFailed === true ? t('Re-verify') : t('Verify')}
          </Button>
          <Button
            onClick={() => setOpenDialogVerify(false)}
            variant="contained"
            className="mainBtn"
            color="primary"
          >
            {t('Cancel')}
          </Button>
        </DialogActions>
      </Dialog>

      <DialogMsg
        openDialogeMsg={openDialogeMsg}
        dialogMsg={dialogMsg}
        dialogTitle="Message"
        buttonText="Close"
        closeDialogMsgHandler={closeDialogMsgHandler}
      />
    </>
  );
};

const Step2Content = ({ handleNext, handlePrev, userAccessValues, DispatchUserAccesValues }) => {
  const { t } = useTranslation();
  const [validationMsg, setValidationMsg] = useState(false); // Validation error

  const localStorageLangKey = localStorage.getItem('i18nextLng');
  const selectedLang = localStorageLangKey ? localStorageLangKey : '';

  const BranchList = {
    en: [
      'HEAD OFFICE SURAT',
      'SALABATPURA SURAT',
      'KOHINOOR MKT BEGUMPURA SURAT',
      'NEW BOMBAY MARKET SURAT'
    ],
    hi: [
      'प्रधान कार्यालय सूरत',
      'सलाबतपुरा सूरत',
      'कोहिनूर मार्केट बेगमपुरा सूरत',
      'न्यू बॉम्बे मार्केट सूरत'
    ],
    gj: [
      'મુખ્ય કાર્યાલય સુરત',
      'સલાબતપુરા સુરત',
      'કોહિનૂર મુક્ત બેગમપુરા સુરત',
      'ન્યુ બોમ્બે માર્કેટ સુરત'
    ]
  };
  const IncomeList = {
    en: [
      'Below 50000',
      '1 lakh to 5 lakhs',
      '5 lakhs to 10 lakhs',
      '10 to 25 lakhs',
      '25 lakhs to 99 lacs',
      '1 Cr to 5 CR'
    ],
    hi: [
      '50000 से नीचे',
      '1 लाख से 5 लाख',
      '5 लाख से 10 लाख',
      '10 से 25 लाख',
      '25 लाख से 99 लाख',
      '1 करोड़ से 5 करोड़'
    ],
    gj: [
      '50000 ની નીચે',
      '1 લાખથી 5 લાખ',
      '5 લાખથી 10 લાખ',
      '10 થી 25 લાખ',
      '25 લાખથી 99 લાખ',
      '1 કરોડથી 5 CR'
    ]
  };
  const EducationList = {
    en: ['Bachelor', 'Below 10th std', 'Illiterate', 'Master', 'PHD', '12th std', 'Other'],
    hi: [
      'अविवाहित पुरुष',
      'दसवीं कक्षा से नीचे',
      'निरक्षर',
      'मालिक',
      'पीएचडी',
      '12वीं कक्षा',
      'अन्य'
    ],
    gj: ['બેચલર', 'ધોરણ 10થી નીચે', 'અભણ', 'માસ્ટર', 'PHD', '12મું ધોરણ', 'અન્ય']
  };

  return (
    <>
      {/* <Typography variant="subtitle2" mb={1} className="FormLabel">
              <FormLabel required>Other Details</FormLabel>
            </Typography> */}
      <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel required>{t('Religion')}</FormLabel>
          </Typography>
          <Typography>
            <Select
              fullWidth
              value={userAccessValues.religion}
              onChange={(e) => DispatchUserAccesValues({ type: 'religion', value: e.target.value })}
              className="frmHelperAlign"
              inputProps={{
                className: `formControl dissabledMenu${userAccessValues.religion}`
              }}
              displayEmpty
              error={userAccessValues.religion === '' ? validationMsg : false}
              renderValue={(selected) => (selected === '' ? t('Religion') : selected)}
              // style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
            >
              <MenuItem value="" disabled>
                {t('Religion')}
              </MenuItem>
              <MenuItem value="Hindu">{t('Hindu')}</MenuItem>
              <MenuItem value="Muslim">{t('Muslim')}</MenuItem>
              <MenuItem value="Christian">{t('Christian')}</MenuItem>
              <MenuItem value="Buddhist">{t('Buddhist')}</MenuItem>
            </Select>
            <FormHelperText className="selectHelper" error>
              {userAccessValues.religion === '' && validationMsg
                ? `${t('Please select')} ${t('Religion').toLowerCase()}`
                : ''}
            </FormHelperText>
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel required>{t('Education')}</FormLabel>
          </Typography>
          <Typography>
            <Select
              fullWidth
              value={userAccessValues.education}
              onChange={(e) =>
                DispatchUserAccesValues({ type: 'education', value: e.target.value })
              }
              className="frmHelperAlign"
              inputProps={{
                className: `formControl dissabledMenu${userAccessValues.education}`
              }}
              displayEmpty
              error={userAccessValues.education === '' ? validationMsg : false}
              renderValue={(selected) => (selected === '' ? t('Education') : selected)}
              // style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
            >
              <MenuItem value="" disabled>
                {t('Education')}
              </MenuItem>
              {EducationList[selectedLang]?.map((education, educationIndex) => (
                <MenuItem key={educationIndex} value={education}>
                  {education}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText className="selectHelper" error>
              {userAccessValues.education === '' && validationMsg
                ? `${t('Please select')} ${t('Education').toLowerCase()}`
                : ''}
            </FormHelperText>
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel required>{t('Annual Income')}</FormLabel>
          </Typography>
          <Typography>
            <Select
              fullWidth
              value={userAccessValues.annualIncome}
              onChange={(e) =>
                DispatchUserAccesValues({ type: 'annualIncome', value: e.target.value })
              }
              className="frmHelperAlign"
              inputProps={{
                className: `formControl dissabledMenu${userAccessValues.annualIncome}`
              }}
              displayEmpty
              error={userAccessValues.annualIncome === '' ? validationMsg : false}
              renderValue={(selected) => (selected === '' ? t('Annual Income') : selected)}
              // style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
            >
              <MenuItem value="" disabled>
                {t('Annual Income')}
              </MenuItem>
              {IncomeList[selectedLang]?.map((income, incomeIndex) => (
                <MenuItem key={incomeIndex} value={income}>
                  {income}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText className="selectHelper" error>
              {userAccessValues.annualIncome === '' && validationMsg
                ? `${t('Please select')} ${t('Annual Income').toLowerCase()}`
                : ''}
            </FormHelperText>
          </Typography>
        </Grid>
        {/* <Grid item xs={12} sm={6} md={4}>
                <Typography variant="body2" mb={1} className="FormLabel">
                  <FormLabel required>Account Type</FormLabel>
                </Typography>
                <Typography>
                  <Select
                    fullWidth
                    value={userAccessValues.account_type}
                    onChange={(e) =>
                      DispatchUserAccesValues({ type: 'account_type', value: e.target.value })
                    }
                    className="frmHelperAlign"
                    inputProps={{
                      className: 'formControl'
                    }}
                    displayEmpty
                    error={userAccessValues.account_type === '' ? validationMsg : false}
                    renderValue={(selected) => (selected === '' ? 'Account Type' : selected)}
                    style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
                  >
                    <MenuItem value="" disabled>
                      Account Type
                    </MenuItem>
                    <MenuItem value="Savings account">Savings account</MenuItem>
                    <MenuItem value="Loan account">Loan account</MenuItem>
                    <MenuItem value="Deposit account">Deposit account</MenuItem>
                    <MenuItem value="Normal account">Normal account</MenuItem>
                  </Select>
                </Typography>
              </Grid> */}
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel required>{t('Branch Details')}</FormLabel>
          </Typography>
          <Typography>
            <Select
              fullWidth
              value={userAccessValues.branch}
              onChange={(e) => {
                DispatchUserAccesValues({
                  type: 'branch',
                  value: e.target.value
                });
              }}
              className="frmHelperAlign"
              inputProps={{
                className: 'formControl'
              }}
              displayEmpty
              error={userAccessValues.branch === '' ? validationMsg : false}
              renderValue={(selected) => (selected === '' ? t('Branch') : selected)}
            >
              <MenuItem value="" disabled>
                {t('Select')} {t('Branch')}
              </MenuItem>
              {BranchList[selectedLang]?.map((branch, branchIndex) => (
                <MenuItem key={branchIndex} value={branch}>
                  {branch}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText className="selectHelper" error>
              {userAccessValues.branch === '' && validationMsg
                ? `${t('Please select')} ${t('Branch').toLowerCase()}`
                : ''}
            </FormHelperText>
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel required>{t('Email id')}</FormLabel>
          </Typography>
          <Typography>
            <TextField
              fullWidth
              type="text"
              className="frmHelperAlign"
              inputProps={{
                className: 'formControl'
              }}
              placeholder={t('Email id')}
              value={userAccessValues.emailId}
              onChange={(e) => DispatchUserAccesValues({ type: 'emailId', value: e.target.value })}
              error={userAccessValues.emailId === '' ? validationMsg : false}
              helperText={
                (userAccessValues.emailId === undefined || userAccessValues.emailId === '') &&
                validationMsg === true
                  ? `${t('Please fill')} ${t('Email id')}`
                  : ''
              }
            />
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel required>{t('Category')}</FormLabel>
          </Typography>
          <Typography>
            <TextField
              disabled
              fullWidth
              type="text"
              className="frmHelperAlign"
              inputProps={{
                className: 'formControl disableFontColor'
              }}
              placeholder={t('Category')}
              value={userAccessValues.category}
              // onChange={(e) =>
              //   DispatchUserAccesValues({ type: 'category', value: e.target.value })
              // }
              // error={userAccessValues.category === '' ? validationMsg : false}
              // helperText={
              //   (userAccessValues.category === undefined || userAccessValues.category === '') &&
              //   validationMsg === true
              //     ? 'Please fill account type'
              //     : ''
              // }
            />
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel required>{t('Nationality')}</FormLabel>
          </Typography>
          <Typography>
            <TextField
              disabled
              fullWidth
              type="text"
              className="frmHelperAlign"
              inputProps={{
                className: 'formControl disableFontColor'
              }}
              placeholder={t('Nationality')}
              value={userAccessValues.nationality}
              onChange={(e) =>
                DispatchUserAccesValues({ type: 'nationality', value: e.target.value })
              }
              error={userAccessValues.nationality === '' ? validationMsg : false}
              helperText={
                (userAccessValues.nationality === undefined ||
                  userAccessValues.nationality === '') &&
                validationMsg === true
                  ? `${t('Please fill')} ${t('Nationality').toLowerCase()}`
                  : ''
              }
            />
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel required>{t('Residential Status')}</FormLabel>
          </Typography>
          <Typography>
            <TextField
              disabled
              fullWidth
              type="text"
              className="frmHelperAlign"
              inputProps={{
                className: 'formControl disableFontColor'
              }}
              placeholder={t('Residential Status')}
              value={userAccessValues.residentStatus}
              onChange={(e) =>
                DispatchUserAccesValues({ type: 'residentStatus', value: e.target.value })
              }
              error={userAccessValues.residentStatus === '' ? validationMsg : false}
              helperText={
                (userAccessValues.residentStatus === undefined ||
                  userAccessValues.residentStatus === '') &&
                validationMsg === true
                  ? `${t('Please fill')} ${t('Residential Status').toLowerCase()}`
                  : ''
              }
            />
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel required>{t('Customer type')}</FormLabel>
          </Typography>
          <Typography>
            <TextField
              disabled
              fullWidth
              type="text"
              className="frmHelperAlign"
              inputProps={{
                className: 'formControl disableFontColor'
              }}
              placeholder={t('Customer type')}
              value={userAccessValues.customerType}
              onChange={(e) =>
                DispatchUserAccesValues({ type: 'customerType', value: e.target.value })
              }
              error={userAccessValues.customerType === '' ? validationMsg : false}
              helperText={
                (userAccessValues.customerType === undefined ||
                  userAccessValues.customerType === '') &&
                validationMsg === true
                  ? `${t('Please fill')} ${t('customer type')}`
                  : ''
              }
            />
          </Typography>
        </Grid>
      </Grid>

      <Box Container textAlign="right" mt={3}>
        <Link className="mainBtn btnLink" onClick={handlePrev}>
          {t('Prev')}
        </Link>
        <Button
          className="mainBtn"
          onClick={() => {
            // Check if field blank
            if (
              userAccessValues.religion === '' ||
              userAccessValues.education === '' ||
              userAccessValues.annualIncome === '' ||
              userAccessValues.branch === '' ||
              userAccessValues.emailId === '' ||
              userAccessValues.category === '' ||
              userAccessValues.nationality === '' ||
              userAccessValues.residentStatus === '' ||
              userAccessValues.customerType === ''
            ) {
              setValidationMsg(true);
              return;
            }

            setValidationMsg(false);
            handleNext();
          }}
        >
          {t('Next')}
        </Button>
        {/* <Link to="/in/summary" className="mainBtn" onClick={{ handleNext }}>
          Next
        </Link> */}
      </Box>
    </>
  );
};

const Step3Content = ({ handleNext, handlePrev, userAccessValues, DispatchUserAccesValues }) => {
  const [validationMsg, setValidationMsg] = useState(false); // Validation error
  const { t } = useTranslation();
  const [isCheckedforValidation, setIsCheckedforValidation] = useState(false); // Validation error

  const Area = ['Ahmedabad', 'Barwala', 'Bavla', 'Dascroi'];

  const Pincode = ['380001', '382450', '382220', '380058'];

  const [userAddressAccessValues, setUserAddressAccessValues] = useState({
    address: {
      address: '',
      state: '',
      // district: '',
      // area: '',
      // city: '',
      // house_buiding_no: '',
      // street: '',
      // landmark: '',
      city_district: '',
      landmark: '',
      pincode: ''
      // country: ''
    },
    corresponding_address: {
      sameAsPermanent: false,
      address: '',
      state: '',
      // district: '',
      // area: '',
      // city: '',
      // house_buiding_no: '',
      // street: '',
      // landmark: '',
      city_district: '',
      landmark: '',
      pincode: ''
      // country: ''
    }
  });

  const handleCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    setIsCheckedforValidation(isChecked); // used for correspondence form validation by bass when same as permanent address checked (checkbox)
    setUserAddressAccessValues((prevValues) => ({
      ...prevValues,
      corresponding_address: {
        ...prevValues.corresponding_address,
        sameAsPermanent: isChecked
      }
    }));

    if (isChecked) {
      DispatchUserAccesValues({
        type: 'corresponding_address',
        value: userAccessValues.address
      });
      DispatchUserAccesValues({
        type: 'corresponding_state',
        value: userAccessValues.permanent_state
      });
      DispatchUserAccesValues({
        type: 'corresponding_district',
        value: userAccessValues.permanent_district
      });
      // DispatchUserAccesValues({
      //   type: 'corresponding_city',
      //   value: userAccessValues.permanent_city
      // });
      DispatchUserAccesValues({
        type: 'corresponding_area',
        value: userAccessValues.permanent_area
      });
      DispatchUserAccesValues({
        type: 'corresponding_pincode',
        value: userAccessValues.permanent_pincode
      });
    }
  };

  useEffect(() => {
    if (userAccessValues) {
      const userData = userDataFromLocal();
      if (
        userData &&
        userData?.OCR?.doc_aadhar &&
        Object.keys(userData?.OCR?.doc_aadhar).length > 0
      ) {
        Object.keys(userData?.OCR?.doc_aadhar).forEach((key) => {
          Object.keys(userAddressAccessValues).forEach((localData) => {
            if (key === localData) {
              // DispatchUserAccesValues({
              //   type: key,
              //   value: userData?.OCR?.doc_aadhar[key]
              //   // value: Object.values(userData?.OCR?.doc_aadhar)[index]
              // });
              setUserAddressAccessValues((preValue) => {
                return {
                  ...preValue,
                  address: {
                    ...preValue.address,
                    [key]: userData?.OCR?.doc_aadhar[key]
                  }
                };
              });
            }
          });
        });
      }
    }
  }, []);

  return (
    <>
      <Typography variant="subtitle2" className="" mb={1}>
        {t('Permanent Address')}
      </Typography>
      <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={12} sm={12} md={12}>
          {/* Your existing textarea for Permanent Address */}

          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel required>{t('Address')}</FormLabel>
          </Typography>
          <Typography>
            <TextField
              fullWidth
              multiline
              rows={5}
              placeholder={`${t('Enter')} ${t('Permanent Address').toLowerCase()}`}
              value={userAccessValues.address}
              onChange={(e) =>
                DispatchUserAccesValues({
                  type: 'address',
                  value: e.target.value
                })
              }
              error={userAccessValues.address === '' ? validationMsg : false}
              helperText={
                (userAccessValues.address === undefined || userAccessValues.address === '') &&
                validationMsg === true
                  ? `${t('Please fill')} ${t('Address').toLowerCase()}`
                  : ''
              }
            />
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel required>{t('State')}</FormLabel>
          </Typography>
          <Typography>
            <TextField
              fullWidth
              // type="number"
              placeholder={`${t('Enter')} ${t('State').toLowerCase()}`}
              className="frmHelperAlign"
              inputProps={{
                className: 'formControl'
              }}
              value={userAccessValues.permanent_state}
              onChange={(e) =>
                DispatchUserAccesValues({
                  type: 'permanent_state',
                  value: e.target.value
                })
              }
              error={userAccessValues.permanent_state === '' ? validationMsg : false}
              helperText={
                (userAccessValues.permanent_state === undefined ||
                  userAccessValues.permanent_state === '') &&
                validationMsg === true
                  ? `${t('Please fill')} ${t('State').toLowerCase()}`
                  : ''
              }
            />
            {/* <Select
              fullWidth
              value={userAccessValues.permanent_state}
              onChange={(e) =>
                DispatchUserAccesValues({
                  type: 'permanent_state',
                  value: e.target.value
                })
              }
              displayEmpty
              error={userAccessValues.permanent_state === '' ? validationMsg : false}
              renderValue={(selected) => (selected === '' ? 'Select State' : selected)}
              className="frmHelperAlign"
              inputProps={{
                className: 'formControl'
              }}
              // style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
            >
              <MenuItem value="" disabled>
                Select State
              </MenuItem>
            </Select> */}
            {/* <FormHelperText className="selectHelper" error>
              {userAccessValues.permanent_state === '' && validationMsg
                ? 'Please select state'
                : ''}
            </FormHelperText> */}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel required>{t('District')}</FormLabel>
          </Typography>
          <TextField
            fullWidth
            // type="number"
            placeholder={`${t('Enter')} ${t('District').toLowerCase()}`}
            className="frmHelperAlign"
            inputProps={{
              className: 'formControl'
            }}
            value={userAccessValues.permanent_district}
            onChange={(e) =>
              DispatchUserAccesValues({
                type: 'permanent_district',
                value: e.target.value
              })
            }
            error={userAccessValues.permanent_district === '' ? validationMsg : false}
            helperText={
              (userAccessValues.permanent_district === undefined ||
                userAccessValues.permanent_district === '') &&
              validationMsg === true
                ? `${t('Please fill')} ${t('District').toLowerCase()}`
                : ''
            }
          />
          {/* <Select
            fullWidth
            value={userAccessValues.permanent_district}
            onChange={(e) =>
              DispatchUserAccesValues({
                type: 'permanent_district',
                value: e.target.value
              })
            }
            displayEmpty
            error={userAccessValues.permanent_district === '' ? validationMsg : false}
            renderValue={(selected) => (selected === '' ? 'Disctrict' : selected)}
            className="frmHelperAlign"
            inputProps={{
              className: 'formControl'
            }}
          >
            <MenuItem value="" disabled>
              Select District
            </MenuItem>
          </Select>
          <FormHelperText className="selectHelper" error>
            {userAccessValues.permanent_district === '' && validationMsg
              ? 'Please select district'
              : ''}
          </FormHelperText> */}
        </Grid>
        {/* <Grid item xs={12} sm={6} md={4}> */}
        {/* <Typography variant="body2" mb={1} className="FormLabel">
              <FormLabel required>City</FormLabel>
            </Typography>
            <Typography>
              <TextField
                fullWidth
                placeholder="Enter city"
                className="frmHelperAlign"
                inputProps={{
                  className: 'formControl'
                }}
                value={userAccessValues.permanent_city}
                onChange={(e) => {
                  if (e.target.value.length < 7) {
                    DispatchUserAccesValues({
                      type: 'permanent_city',
                      value: e.target.value
                    });
                  }
                }}
                error={userAccessValues.permanent_city === '' ? validationMsg : false}
                helperText={
                  (userAccessValues.permanent_city === undefined ||
                    userAccessValues.permanent_city === '') &&
                  validationMsg === true
                    ? 'Please fill city'
                    : ''
                }
              /> */}

        {/* <Select
                fullWidth
                value={userAccessValues.permanent_city}
                onChange={(e) =>
                  DispatchUserAccesValues({
                    type: 'permanent_city',
                    value: e.target.value
                  })
                }
                displayEmpty
                error={userAccessValues.permanent_city === '' ? validationMsg : false}
                renderValue={(selected) => (selected === '' ? 'City' : selected)}
                className="frmHelperAlign"
                inputProps={{
                  className: 'formControl'
                }}
              >
                <MenuItem value="" disabled>
                  Select City
                </MenuItem>
              </Select>
              <FormHelperText className="selectHelper" error>
                {userAccessValues.permanent_city === '' && validationMsg
                  ? 'Please select city'
                  : ''}
              </FormHelperText> */}
        {/* </Typography>
          </Grid> */}
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel required>{t('Area')}</FormLabel>
          </Typography>
          <Typography>
            <TextField
              fullWidth
              // type="number"
              placeholder={`${t('Enter')} ${t('Area').toLowerCase()}`}
              className="frmHelperAlign"
              inputProps={{
                className: 'formControl'
              }}
              value={userAccessValues.permanent_area}
              onChange={(e) =>
                DispatchUserAccesValues({
                  type: 'permanent_area',
                  value: e.target.value
                })
              }
              error={userAccessValues.permanent_area === '' ? validationMsg : false}
              helperText={
                (userAccessValues.permanent_area === undefined ||
                  userAccessValues.permanent_area === '') &&
                validationMsg === true
                  ? `${t('Please fill')} ${t('Area').toLowerCase()}`
                  : ''
              }
            />

            {/* <Select
                fullWidth
                value={userAccessValues.permanent_area}
                onChange={(e) =>
                  DispatchUserAccesValues({
                    type: 'permanent_area',
                    value: e.target.value
                  })
                }
                displayEmpty
                error={userAccessValues.permanent_area === '' ? validationMsg : false}
                renderValue={(selected) => (selected === '' ? 'Area' : selected)}
                className="frmHelperAlign"
                inputProps={{
                  className: 'formControl'
                }}
              >
                <MenuItem value="" disabled>
                  Select Area
                </MenuItem>
                {Area?.map((area, areaIndex) => (
                  <MenuItem key={areaIndex} value={area}>
                    {area}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText className="selectHelper" error>
                {userAccessValues.permanent_area === '' && validationMsg
                  ? 'Please select area'
                  : ''}
              </FormHelperText> */}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2" mb={1} className="FormLabel">
            <FormLabel required>{t('Pincode')}</FormLabel>
          </Typography>
          <Typography>
            <TextField
              fullWidth
              type="number"
              placeholder={`${t('Enter')} ${t('Pincode').toLowerCase()}`}
              className="frmHelperAlign"
              inputProps={{
                className: 'formControl'
              }}
              value={userAccessValues.permanent_pincode}
              onChange={(e) => {
                if (e.target.value.length < 7) {
                  DispatchUserAccesValues({
                    type: 'permanent_pincode',
                    value: e.target.value
                  });
                }
              }}
              error={userAccessValues.permanent_pincode === '' ? validationMsg : false}
              helperText={
                (userAccessValues.permanent_pincode === undefined ||
                  userAccessValues.permanent_pincode === '') &&
                validationMsg === true
                  ? `${t('Please fill')} ${t('pincode').toLowerCase()}`
                  : ''
              }
            />
          </Typography>
        </Grid>
      </Grid>

      {/* Correspondence Address Section */}
      <Typography variant="subtitle2" mt={3}>
        {t('Correspondence Address')}
      </Typography>

      <Box mb={1}>
        <FormControlLabel
          control={
            <Checkbox
              checked={userAddressAccessValues.corresponding_address.sameAsPermanent}
              onChange={handleCheckboxChange}
              size="small"
            />
          }
          label={<Typography variant="body2">{t('Same as Permanent Address')}</Typography>}
        />
        {/* <Checkbox
          checked={userAddressAccessValues.corresponding_address.sameAsPermanent}
          onChange={handleCheckboxChange}
        /> */}
      </Box>

      {/* Fields for Correspondence Address */}
      {!userAddressAccessValues.corresponding_address.sameAsPermanent && (
        <>
          <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
            <Grid item xs={12} sm={12} md={12}>
              <Typography variant="body2" mb={1} className="FormLabel">
                <FormLabel required>{t('Address')}</FormLabel>
              </Typography>
              <Typography>
                <TextField
                  fullWidth
                  placeholder={`${t('Enter')} ${t('Address').toLowerCase()}`}
                  multiline
                  rows={5}
                  value={userAccessValues.corresponding_address}
                  onChange={(e) =>
                    DispatchUserAccesValues({
                      type: 'corresponding_address',
                      value: e.target.value
                    })
                  }
                  error={userAccessValues.corresponding_address === '' ? validationMsg : false}
                  // helperText={
                  //   (userAccessValues.corresponding_address === undefined ||
                  //     userAccessValues.corresponding_address === '') &&
                  //   validationMsg === true
                  //     ? 'Please fill corresponding address'
                  //     : ''
                  // }
                />
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="body2" mb={1} className="FormLabel">
                <FormLabel required>{t('State')}</FormLabel>
              </Typography>
              <Typography>
                <TextField
                  fullWidth
                  // type="number"
                  placeholder={`${t('Enter')} ${t('State').toLowerCase()}`}
                  className="frmHelperAlign"
                  inputProps={{
                    className: 'formControl'
                  }}
                  value={userAccessValues.corresponding_state}
                  onChange={(e) =>
                    DispatchUserAccesValues({
                      type: 'corresponding_state',
                      value: e.target.value
                    })
                  }
                  error={userAccessValues.corresponding_state === '' ? validationMsg : false}
                  // helperText={
                  //   (userAccessValues.corresponding_state === undefined ||
                  //     userAccessValues.corresponding_state === '') &&
                  //   validationMsg === true
                  //     ? 'Please fill area'
                  //     : ''
                  // }
                />
                {/* <Select
                      fullWidth
                      value={userAccessValues.corresponding_state}
                      onChange={(e) =>
                        DispatchUserAccesValues({
                          type: 'corresponding_state',
                          value: e.target.value
                        })
                      }
                      displayEmpty
                      error={userAccessValues.corresponding_state === '' ? validationMsg : false}
                      renderValue={(selected) => (selected === '' ? 'State' : selected)}
                      className="frmHelperAlign"
                      inputProps={{
                        className: 'formControl'
                      }}
                    >
                      <MenuItem value="" disabled>
                        Select State
                      </MenuItem>
                    </Select> */}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="body2" mb={1} className="FormLabel">
                <FormLabel required>{t('District')}</FormLabel>
              </Typography>
              <Typography>
                <TextField
                  fullWidth
                  // type="number"
                  placeholder={`${t('Enter')} ${t('District').toLowerCase()}`}
                  className="frmHelperAlign"
                  inputProps={{
                    className: 'formControl'
                  }}
                  value={userAccessValues.corresponding_district}
                  onChange={(e) =>
                    DispatchUserAccesValues({
                      type: 'corresponding_district',
                      value: e.target.value
                    })
                  }
                  error={userAccessValues.corresponding_district === '' ? validationMsg : false}
                  // helperText={
                  //   (userAccessValues.corresponding_area === undefined ||
                  //     userAccessValues.corresponding_area === '') &&
                  //   validationMsg === true
                  //     ? 'Please fill area'
                  //     : ''
                  // }
                />
                {/* <Select
                      fullWidth
                      value={userAccessValues.corresponding_district}
                      onChange={(e) =>
                        DispatchUserAccesValues({
                          type: 'corresponding_district',
                          value: e.target.value
                        })
                      }
                      displayEmpty
                      error={userAccessValues.corresponding_district === '' ? validationMsg : false}
                      renderValue={(selected) => (selected === '' ? 'District' : selected)}
                      className="frmHelperAlign"
                      inputProps={{
                        className: 'formControl'
                      }}
                    >
                      <MenuItem value="" disabled>
                        Select District
                      </MenuItem>
                    </Select> */}
              </Typography>
            </Grid>
            {/* <Grid item xs={12} sm={6} md={4}>
                  <Typography variant="body2" mb={1} className="FormLabel">
                    <FormLabel required>City</FormLabel>
                  </Typography>
                  <Typography>
                    <Select
                      fullWidth
                      value={userAccessValues.corresponding_city}
                      onChange={(e) =>
                        DispatchUserAccesValues({
                          type: 'corresponding_city',
                          value: e.target.value
                        })
                      }
                      displayEmpty
                      error={userAccessValues.corresponding_city === '' ? validationMsg : false}
                      renderValue={(selected) => (selected === '' ? 'City' : selected)}
                      className="frmHelperAlign"
                      inputProps={{
                        className: 'formControl'
                      }}
                    >
                      <MenuItem value="" disabled>
                        Select City
                      </MenuItem>
                    </Select>
                  </Typography>
                </Grid> */}
            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="body2" mb={1} className="FormLabel">
                <FormLabel required>{t('Area')}</FormLabel>
              </Typography>
              <Typography>
                <TextField
                  fullWidth
                  // type="number"
                  placeholder={`${t('Enter')} ${t('Area').toLowerCase()}`}
                  className="frmHelperAlign"
                  inputProps={{
                    className: 'formControl'
                  }}
                  value={userAccessValues.corresponding_area}
                  onChange={(e) =>
                    DispatchUserAccesValues({
                      type: 'corresponding_area',
                      value: e.target.value
                    })
                  }
                  error={userAccessValues.corresponding_area === '' ? validationMsg : false}
                  // helperText={
                  //   (userAccessValues.corresponding_area === undefined ||
                  //     userAccessValues.corresponding_area === '') &&
                  //   validationMsg === true
                  //     ? 'Please fill area'
                  //     : ''
                  // }
                />
                {/* <Select
                      fullWidth
                      value={userAccessValues.corresponding_area}
                      onChange={(e) =>
                        DispatchUserAccesValues({
                          type: 'corresponding_area',
                          value: e.target.value
                        })
                      }
                      displayEmpty
                      error={userAccessValues.corresponding_area === '' ? validationMsg : false}
                      renderValue={(selected) => (selected === '' ? 'Area' : selected)}
                      className="frmHelperAlign"
                      inputProps={{
                        className: 'formControl'
                      }}
                    >
                      <MenuItem value="" disabled>
                        Select Area
                      </MenuItem>
                      {Area?.map((area, areaIndex) => (
                        <MenuItem key={areaIndex} value={area}>
                          {area}
                        </MenuItem>
                      ))}
                    </Select> */}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="body2" mb={1} className="FormLabel">
                <FormLabel required>{t('Pincode')}</FormLabel>
              </Typography>
              <Typography>
                <TextField
                  fullWidth
                  placeholder={`${t('Enter')} ${t('Pincode').toLowerCase()}`}
                  className="frmHelperAlign"
                  inputProps={{
                    className: 'formControl'
                  }}
                  value={userAccessValues.corresponding_pincode}
                  onChange={(e) => {
                    if (e.target.value.length < 7) {
                      DispatchUserAccesValues({
                        type: 'corresponding_pincode',
                        value: e.target.value
                      });
                    }
                  }}
                  // displayEmpty
                  error={userAccessValues.corresponding_pincode === '' ? validationMsg : false}
                />
              </Typography>
            </Grid>
          </Grid>
        </>
      )}
      <Box Container textAlign="right" mt={2}>
        <Link className="mainBtn btnLink" onClick={handlePrev}>
          {t('Prev')}
        </Link>
        <Button
          className="mainBtn"
          onClick={() => {
            // if (userAccessValues.address === '') {
            //   setValidationMsg(true);
            //   return;
            // } else if (userAccessValues.permanent_state === '') {
            //   setValidationMsg(true);
            //   return;
            // } else if (userAccessValues.permanent_district === '') {
            //   setValidationMsg(true);
            //   return;
            // } else if (userAccessValues.permanent_area === '') {
            //   setValidationMsg(true);
            //   return;
            // } else if (userAccessValues.permanent_pincode === '') {
            //   setValidationMsg(true);
            //   return;
            // } else if (
            //   isCheckedforValidation === false &&
            //   userAccessValues.corresponding_address === ''
            // ) {
            //   setValidationMsg(true);
            //   return;
            // } else if (
            //   isCheckedforValidation === false &&
            //   userAccessValues.corresponding_state === ''
            // ) {
            //   setValidationMsg(true);
            //   return;
            // } else if (
            //   isCheckedforValidation === false &&
            //   userAccessValues.corresponding_district === ''
            // ) {
            //   setValidationMsg(true);
            //   return;
            // } else if (
            //   isCheckedforValidation === false &&
            //   userAccessValues.corresponding_area === ''
            // ) {
            //   setValidationMsg(true);
            //   return;
            // } else if (
            //   isCheckedforValidation === false &&
            //   userAccessValues.corresponding_pincode === ''
            // ) {
            //   setValidationMsg(true);
            //   return;
            // } else {
            //   setValidationMsg(false);
            //   handleNext();
            // }

            if (
              userAccessValues.address === '' ||
              userAccessValues.permanent_state === '' ||
              userAccessValues.permanent_district === '' ||
              userAccessValues.permanent_area === '' ||
              userAccessValues.permanent_pincode === ''
            ) {
              setValidationMsg(true);
              return;
            }

            if (!isCheckedforValidation) {
              if (
                userAccessValues.corresponding_address === '' ||
                userAccessValues.corresponding_state === '' ||
                userAccessValues.corresponding_district === '' ||
                userAccessValues.corresponding_area === '' ||
                userAccessValues.corresponding_pincode === ''
              ) {
                setValidationMsg(true);
                return;
              }
            }

            setValidationMsg(false);
            handleNext();
          }}
        >
          {t('Next')}
        </Button>
        {/* <Link to="/in/summary" className="mainBtn" onClick={{ handleNext }}>
          Next
        </Link> */}
      </Box>
    </>
  );
};

const Step4Content = ({ handlePrev, setActiveStep, userAccessValues, handleSaveUserInfoApi }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [openSec, setOpenSec] = useState(false);
  const [mobileNumber, setMobileNumber] = useState('');

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickOpenSec = () => {
    setOpenSec(true);
  };

  const handleCloseSec = () => {
    setOpenSec(false);
  };

  const hanClickCorrect = () => {
    setActiveStep(0);
  };

  useEffect(() => {
    const userData = userDataFromLocal();
    setMobileNumber(userData?.mobileNumber);
  }, []);

  return (
    <>
      <Stack className="summaryStep">
        <Box mb={2}>
          <Typography variant="subtitle2">{t('Registration information')}</Typography>
        </Box>
        <Box position="relative">
          <img
            className="backgroundLogo"
            src="/static/logo/finco-logo-w.png"
            alt="Background Logo"
          />
          <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl className="formGroup">
                <Typography variant="subtitle2" mb={1} className="FormLabel summaryLabel">
                  {t('Customer Full Name')}
                </Typography>
                <Typography variant="subtitle2" className="FormLabel">
                  {userAccessValues?.name}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl className="formGroup">
                <Typography variant="subtitle2" mb={1} className="FormLabel summaryLabel">
                  {t('Date of birth')}
                </Typography>
                <Typography variant="subtitle2" className="FormLabel">
                  {userAccessValues?.date_of_birth}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl className="formGroup">
                <Typography variant="subtitle2" mb={1} className="FormLabel summaryLabel">
                  {t('Aadhar card number')}
                </Typography>
                <Typography variant="subtitle2" className="FormLabel">
                  {userAccessValues?.aadhaar_number}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl className="formGroup">
                <Typography variant="subtitle2" mb={1} className="FormLabel summaryLabel">
                  {t('Pan number')}
                </Typography>
                <Typography variant="subtitle2" className="FormLabel">
                  {userAccessValues?.pan_card_number}
                </Typography>
              </FormControl>
            </Grid>
            {/* <Grid item xs={12} sm={6} md={4}Bottom={3}>
              <FormControl className="formGroup">
                <Typography variant="subtitle2" mb={1} className="FormLabel summaryLabel">
                  A/cType
                </Typography>
                <Typography variant="subtitle2" className="FormLabel">
                  {userAccessValues?.account_type}
                </Typography>
              </FormControl>
            </Grid> */}
            <Grid item xs={12} sm={6} md={4}>
              <FormControl className="formGroup">
                <Typography variant="subtitle2" mb={1} className="FormLabel summaryLabel">
                  {t('Branch')}
                </Typography>
                <Typography variant="subtitle2" className="FormLabel">
                  {userAccessValues?.branch ? userAccessValues?.branch : ''}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl className="formGroup">
                <Typography variant="subtitle2" mb={1} className="FormLabel summaryLabel">
                  {t('Permanent Address')}
                </Typography>
                <Typography variant="subtitle2" className="FormLabel">
                  {userAccessValues?.address}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl className="formGroup">
                <Typography variant="subtitle2" mb={1} className="FormLabel summaryLabel">
                  {t('Correspondence Address')}
                </Typography>
                <Typography variant="subtitle2" className="FormLabel">
                  {userAccessValues?.corresponding_address}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl className="formGroup">
                <Typography variant="subtitle2" mb={1} className="FormLabel summaryLabel">
                  {t('Type of doc Submitted')}
                </Typography>
                <Typography variant="subtitle2" className="FormLabel">
                  {/* {userAccessValues?.doc_url} */}
                  {t('Digital KYC')}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl className="formGroup">
                <Typography variant="subtitle2" mb={1} className="FormLabel summaryLabel">
                  {t('Contact Number')}
                </Typography>
                <Typography variant="subtitle2" className="FormLabel">
                  {mobileNumber ? mobileNumber : ''}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl className="formGroup">
                <Typography variant="subtitle2" mb={1} className="FormLabel summaryLabel">
                  {t('Email Id')}
                </Typography>
                <Typography variant="subtitle2" className="FormLabel">
                  {userAccessValues?.emailId}
                </Typography>
              </FormControl>
            </Grid>
          </Grid>
        </Box>
        <Box Container textAlign="right" mt={2} className="summaryBtnWrap">
          <Button className="mainBtn btnLink" onClick={handleClickOpen}>
            {t('Cancel')}
          </Button>
          <Button
            onClick={hanClickCorrect}
            className="mainBtn btnLink"
            style={{ marginLeft: '8px', marginRight: '8px' }}
          >
            {t('Edit')}
          </Button>
          {/* <Link to="/in/personalinfo" className="mainBtn btnLink">
            Correct
          </Link> */}
          <Button
            to=""
            className="mainBtn btnLink"
            onClick={() => {
              handleSaveUserInfoApi();
            }}
          >
            {t('Confirm')}
          </Button>
        </Box>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="popupBlack"
        >
          <DialogTitle id="alert-dialog-title" className="popupBlackHeading">
            <Box className="popupIconBox">
              <ImNotification className="popupIcon" />
            </Box>
            <Typography variant="subtitle1" color="white">
              {t('Are you sure')}
            </Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description" className="popupBody">
              <Typography variant="subtitle1" className="popUpHeading" mb={2}>
                {t('Confirm')}
              </Typography>
              <Typography variant="body1" className="popupContent" mb={2}>
                {t('Are you sure you want to cancel the manual registration process')}
              </Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="popupFooter">
            <Link className="mainBtn btnLink" to="/in/selfregistration">
              {t('Yes')}
            </Link>
            <Button className="mainBtn" onClick={handleClose} autoFocus>
              {t('No')}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openSec}
          onClose={handleCloseSec}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="popupGreen"
        >
          <DialogTitle id="alert-dialog-title" className="popupGreenHeading">
            <Box className="popupIconBox">
              <FaRegSmile className="popupIcon" />
            </Box>
            <Typography variant="subtitle1" color="white">
              {t('Success')}
            </Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description" className="popupBody">
              <Typography variant="subtitle1" className="popUpHeading" mb={2}>
                {t('Congratulations')}
              </Typography>
              <Typography variant="body1" className="popupContent" mb={2}>
                {t('Your account has been verified')}
              </Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="popupFooter">
            <Link className="mainBtn" to="/in/thanks">
              {t('Continue')}
            </Link>
            {/* <Link className="mainBtn" to="/in/siminfo"> it was before so
              Continue
            </Link> */}
          </DialogActions>
        </Dialog>
      </Stack>
    </>
  );
};
